import React from 'react';
import { Link } from '../Link';
import { Icon } from '../icons/Icon';

/**
 * Secondary link to company profile (same URL as logo block). Used twice: beside the logo
 * (default) and under the job title (narrow grid cells only — see hit-card.css).
 */
export function HitCompanyInsightsCueLink(props: {
  variant: 'in-leading' | 'under-title';
  href: string;
  locale: string;
  title: string;
  insightsCue: string;
  tabIndex?: number;
  /** When true, remove from accessibility tree (duplicate of primary logo/name profile link). */
  ariaHidden?: boolean;
}): React.ReactElement {
  return (
    <Link
      href={props.href}
      locale={props.locale}
      title={props.title}
      tabIndex={props.tabIndex}
      aria-hidden={props.ariaHidden === true ? true : undefined}
      className={`hit-card__company-cue-hit hit-card__company-cue hit-card__company-cue--${props.variant}`}
    >
      <Icon name="buildingOffice2" useMaskForColor className="h-3 w-3 shrink-0 opacity-90" />
      <span>{props.insightsCue}</span>
    </Link>
  );
}
